<div class="inspection-dashboard">
  <wr-inspection-dashboard-filter [mode]="mode()" (filterChange)="filter.set($event)"></wr-inspection-dashboard-filter>
  <wr-inspection-dashboard-list [filter]="filter()" [(mode)]="mode"></wr-inspection-dashboard-list>
</div>
